import Home from './content';
import HomeNavigation from './navigation';

export { Home, HomeNavigation };



// WEBPACK FOOTER //
// ./src/containers/Home/index.js